<template>
  <img
    class="object-contain w-full"
    :class="[
      $attrs.class ? $attrs.class : 'h-10'
    ]"
    alt="Swipe logo"
    src="@/assets/image/logo-swipe.svg"
  />
</template>